/*
* http://usejsdoc.org/
*/
export * from './src/integrador';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/recibo-pago/index.js
// module id = ../../../../../src/app/components/recibo-pago/index.js
// module chunks = main